import { useEffect, useState } from "react";
import { Mail, Plus, ShieldCheck, UserRound } from "lucide-react";
import { SuiteTeamWorkspace } from "@tribunalea/auth/react";
import { PageHeader } from "@tribunalea/ui";
import { useApi, useApp } from "../App.jsx";

export function TeamPage() {
  const api = useApi();
  const { authEnabled } = useApp();
  const [team, setTeam] = useState([]);

  useEffect(() => {
    api.team().then(setTeam);
  }, []);

  if (authEnabled) {
    return (
      <div className="page team-page">
        <PageHeader
          eyebrow="Administración"
          title="Equipo"
          description="Invitá personas y administrá los accesos del estudio."
        />
        <div className="clerk-organization-surface">
          <SuiteTeamWorkspace />
        </div>
      </div>
    );
  }

  return (
    <div className="page team-page">
      <PageHeader
        eyebrow="Administración"
        title="Equipo"
        description="Invitá personas y administrá los accesos del estudio."
        actions={(
          <button
            className="button primary"
            disabled
            title="Disponible al conectar Clerk"
          >
            <Plus size={18} /> Invitar persona
          </button>
        )}
      />

      <div className="demo-banner">
        <ShieldCheck size={19} />
        <span>
          <strong>Vista de demostración</strong>
          Conectá Clerk para habilitar invitaciones, roles y cambios de equipo.
        </span>
      </div>

      <section className="team-card">
        <div className="team-card-header">
          <strong>Miembros</strong>
          <span>{team.length} personas</span>
        </div>
        {team.map((member, index) => (
          <article className="team-row" key={member.id}>
            <span className="member-avatar large">
              {member.name
                .split(" ")
                .slice(0, 2)
                .map((part) => part[0])
                .join("")}
            </span>
            <span className="team-member-copy">
              <strong>
                {member.name}
                {index === 0 && <em>Vos</em>}
              </strong>
              <small>
                <Mail size={13} /> {member.email}
              </small>
            </span>
            <span className="role-badge">
              <UserRound size={14} />
              {index === 0 ? "Administrador" : "Miembro"}
            </span>
          </article>
        ))}
      </section>
    </div>
  );
}
